import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, space } from '../../theme/tokens';
import type { PriceSize } from './PriceDisplay.types';

const fontSizeFor = (size: PriceSize) =>
  size === 'xlarge'
    ? fonts.size['2xl']
    : size === 'large'
    ? fonts.size.xl
    : size === 'medium'
    ? fonts.size.lg
    : size === 'base'
    ? fonts.size.base
    : fonts.size.sm;

const desktopFontSizeFor = (size: PriceSize) =>
  size === 'xlarge' ? fonts.size['3xl'] : fontSizeFor(size);

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: ${space['space-100']};
  align-items: center;
`;

export const UnitWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: ${space['space-100']};
`;

export const PriceLabel = styled.span<{
  $size: PriceSize;
}>`
  font-family: ${fonts.body};
  font-size: ${(p) => fontSizeFor(p.$size)};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${(p) => desktopFontSizeFor(p.$size)};
  }
`;

export const PriceAmount = styled.span<{
  $size: PriceSize;
  $weight?: 'normal' | 'medium' | 'bold';
}>`
  font-family: ${fonts.body};
  font-weight: ${(p) =>
    p.$weight === 'bold'
      ? fonts.weight.bold
      : p.$weight === 'normal'
      ? fonts.weight.normal
      : fonts.weight.medium};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  font-size: ${(p) => fontSizeFor(p.$size)};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${(p) => desktopFontSizeFor(p.$size)};
  }
`;

export const DiscountRow = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: ${space['space-200']};
`;

export const OriginalPrice = styled.span<{
  $size: PriceSize;
}>`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.tertiary};
  text-decoration: line-through;
  font-size: ${(p) => fontSizeFor(p.$size)};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${(p) => desktopFontSizeFor(p.$size)};
  }
`;

export const DiscountedPrice = styled.span<{
  $size: PriceSize;
}>`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  font-size: ${(p) => fontSizeFor(p.$size)};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${(p) => desktopFontSizeFor(p.$size)};
  }
`;
